module.exports = __webpack_public_path__ + "img/icon_account.4cf1d8e7.svg";